/**
 * @file FlatList atom — performant flat list primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family (FlashList aliased as FlatList); the only sanctioned import path for
 * app code (RFC §3).
 * @module components/atoms/FlatList
 */
export { FlatList } from "@/components/ui/flat-list";
